import React from 'react';
import { Typography } from 'antd';
import styled from 'styled-components';
import Helmet from '../../config/helmet';
import GoogleMaps from '../components/GoogleMaps';
import Container from '../components/UI/Container';

const { Title, Text } = Typography;

const Wrapper = styled(Container)`
  padding-top: 100px !important;
  padding-bottom: 2rem;
  height: calc(100vh - 208.17px);

  @media (max-width: 992px) {
    height: 100%;
  }
`;

const Content = styled.div`
  ul {
    margin: 1.5rem !important;

    li {
      list-style: disc;
    }
  }

  @media (min-width: 992.98px) {
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-gap: 1.5rem;
  }
`;

export default () => (
  <Wrapper>
    <Helmet title='Cancellation Policy' />

    <Title>Cancellation Policy</Title>
    <Content>
      <ul>
        <li>
          <Text>
            10% of the deposit is retained as cancellation fee when cancellation is made more than a week before
            arrival.
          </Text>
        </li>
        <li>
          <Text>
            20% of the deposit is retained as cancellation fee when cancellation is made one (1) week before arrival.
          </Text>
        </li>
        <li>
          <Text>Deposit is forfeited as DAMAGE when cancellation is made less than one (1) week before arrival.</Text>
        </li>
        <li>
          <Text>
            Unless for reasons due to inclement weather or accidents, booking may be re-scheduled depending upon the
            availability of rooms.
          </Text>
        </li>
      </ul>
      <GoogleMaps isMarkerShown />
    </Content>
  </Wrapper>
);
